/**
 * 坊市价格波动系统
 * 每6小时波动一次（一天4次），物品价格在 ±30% 间浮动
 */

/** 获取当前时间段（0-3，每6小时一段） */
export function getCurrentSegment(): number {
  const hour = new Date().getHours();
  return Math.floor(hour / 6); // 0=0-5时, 1=6-11时, 2=12-17时, 3=18-23时
}

/** 基于日期+时间段生成确定性的随机种子 */
function getSegmentSeed(segment: number): number {
  const now = new Date();
  const dateKey = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
  // 简单哈希
  let hash = dateKey * 31 + segment * 7;
  hash = (hash << 5) - hash + 12345;
  return Math.abs(hash);
}

/** 伪随机数（基于种子） */
function seededRandom(seed: number): number {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

/** 获取当前全局价格倍率（0.7~1.3） */
export function getCurrentPriceMultiplier(): number {
  const segment = getCurrentSegment();
  const seed = getSegmentSeed(segment);
  return Math.round((0.7 + seededRandom(seed) * 0.6) * 100) / 100;
}

/** 计算物品当前价格 */
export function getCurrentPrice(basePrice: number): number {
  if (basePrice === 0) return 0;
  return Math.max(1, Math.floor(basePrice * getCurrentPriceMultiplier()));
}

/** 获取价格趋势描述 */
export function getPriceTrend(): { multiplier: number; label: string; color: string; nextChange: string } {
  const mult = getCurrentPriceMultiplier();
  let label: string, color: string;

  if (mult > 1.15) { label = '📈 物价飞涨'; color = 'var(--danger)'; }
  else if (mult > 1.05) { label = '📈 物价上涨'; color = '#f90'; }
  else if (mult < 0.85) { label = '📉 物价暴跌'; color = 'var(--success)'; }
  else if (mult < 0.95) { label = '📉 物价下跌'; color = '#6b8'; }
  else { label = '📊 物价平稳'; color = 'var(--text-secondary)'; }

  // 计算下次变动时间
  const segment = getCurrentSegment();
  const nextSegment = (segment + 1) % 4;
  const nextHour = nextSegment * 6;
  const now = new Date();
  const next = new Date(now);
  next.setHours(nextHour, 0, 0, 0);
  if (next <= now) next.setDate(next.getDate() + 1);
  const diffMin = Math.floor((next.getTime() - now.getTime()) / 60000);
  const nextChange = `${Math.floor(diffMin / 60)}时${diffMin % 60}分后`;

  return { multiplier: mult, label, color, nextChange };
}
